import "./Advisories.scss";
import {
  Breadcrumbs,
  Notification,
  Text,
} from "@netapp/bxp-design-system-react";
import Table from "./table/Table";
import { Layout } from "@netapp/bxp-design-system-react/";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import removeComments from "remark-remove-comments";
import { LangLink } from "../../utils/langNavigation";
import SubscribeModal from "../../Components/Subscribe_modal/Subscribe"; // Import the SubscribeModal component
import OtpModal from "../../Components/Subscribe_modal/OtpModal"; // Import the OtpModal component
import UnsubscribeModal from "../../Components/Subscribe_modal/UnsubscribeModal"; // Import the UnsubscribeModal component
import { getContentPath, loadMarkdownContent } from "../../utils/contentLoader";

const Advisories = () => {
  const { i18n, t } = useTranslation();
  const [frontMatter, setFrontMatter] = useState({});
  const [content, setContent] = useState("");
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false); // State to manage subscribe modal visibility
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false); // State to manage OTP modal visibility
  const [isUnsubscribeModalOpen, setIsUnsubscribeModalOpen] = useState(false); // State to manage unsubscribe modal visibility
  const [email, setEmail] = useState(""); // State to store the email for OTP modal
  const [advisoryId, setAdvisoryId] = useState("ntap_all"); // Default advisory ID
  const [notification, setNotification] = useState({
    visible: false,
    message: "",
    type: "success",
  });
  const baseUrl = window.location.origin.replace(/\/advisory$/, "");
  const openSubscribeModalFromTable = (advisoryId) => {
    setAdvisoryId(advisoryId);
    setIsSubscribeModalOpen(true);
  };
  useEffect(() => {
    const loadContent = async () => {
      try {
        const filePath = getContentPath("/content/advisory/_index", i18n.language);
        const { frontMatter: data, content: markdownContent } = await loadMarkdownContent(filePath);
        setFrontMatter(data);
        setContent(markdownContent);
      } catch (error) {
        console.error("Error loading advisory content:", error);
      }
    };
    loadContent();
  }, [i18n.language]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const path = window.location.pathname;
      if (hash === "#unsubscribe") {
        if (path.includes("/advisory/")) {
          const advId = path.split("/advisory/")[1].split("/")[0];
          setAdvisoryId(advId);
        } else {
          setAdvisoryId("ntap_all");
        }
        setIsUnsubscribeModalOpen(true);
      } else {
        setIsUnsubscribeModalOpen(false);
      }
    };

    // Check the initial hash value
    handleHashChange();

    // Add event listener for hash changes
    window.addEventListener("hashchange", handleHashChange);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const handleSubscriptionSuccess = (email) => {
    setEmail(email); // Store the email
    setIsSubscribeModalOpen(false); // Close the subscribe modal
    setIsOtpModalOpen(true); // Open the OTP modal
  };

  return (
    <div className="advisories-page">
      {notification.visible && (
        <Notification type={notification.type}>
          {notification.message}
        </Notification>
      )}
      <Layout.Page className="page-wrapper">
        <Layout.Content className="content-padding">
          <Layout.BreadcrumbsContainer className="breadcrumb-container">
            <Breadcrumbs>
              <LangLink to="/" className="breadcrumbs-link">
                {t("securityPortal.other")}
              </LangLink>
              <div>{t("security_advisories.other")}</div>
            </Breadcrumbs>
          </Layout.BreadcrumbsContainer>
          <div className="title-and-content">
            <Text className="title">{frontMatter.longtitle}</Text>
            <Text className="title-description">
              <span> {frontMatter.slogan} </span>
              <br />
              <span
                className="alert-link"
                onClick={() => {
                  setIsSubscribeModalOpen(true);
                  setAdvisoryId("ntap_all");
                }}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {t("advisory_subscribeToReceiveUpdates.other")}
              </span>
              <span
                className="alert-link"
                onClick={() => {
                  const rssFeedUrl = i18n.language === 'ja' ? `${baseUrl}/ja/advisory/index.xml` : `${baseUrl}/advisory/index.xml`;
                  window.open(rssFeedUrl, "_blank");
                }}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {t("advisory_subscribeRssFeeds.other")}
              </span>
            </Text>
          </div>
          <div className="table-frame">
            <Table openSubscribeModalFromTable={openSubscribeModalFromTable} />
          </div>
        </Layout.Content>
      </Layout.Page>
      {isSubscribeModalOpen && (
        <SubscribeModal
          advisoryId={advisoryId}
          open={isSubscribeModalOpen}
          setOpen={setIsSubscribeModalOpen}
          headerText={
            advisoryId === "ntap_all"
              ? t("advisory_subscribeAllUpdates.other")
              : t("advisory_subscribeToAdvisory.other", { id: advisoryId })
          }
          onSubscriptionSuccess={handleSubscriptionSuccess}
          notification={notification}
          setNotification={setNotification}
        />
      )}
      {isOtpModalOpen && (
        <OtpModal
          email={email} // Pass the email to the OTP modal
          // advisoryId="ntap_all" // Pass the advisory ID
          advisoryId={advisoryId} // Pass the advisory ID
          notification={notification} // Pass the notification state
          setNotification={setNotification} // Pass the setNotification function
          onClose={() => setIsOtpModalOpen(false)} // Close the OTP modal
        />
      )}
      {isUnsubscribeModalOpen && (
        <UnsubscribeModal
          advisoryId={advisoryId}
          open={isUnsubscribeModalOpen}
          setOpen={setIsUnsubscribeModalOpen}
          headerText={
            advisoryId === "ntap_all"
              ? t("advisory_unsubscribeAllUpdates.other")
              : t("advisory_unsubscribeFromAdvisory.other", { id: advisoryId })
          }
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </div>
  );
};

export default Advisories;
